import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-bold q-mb-sm" }, "API Key:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_masked_api_key = _resolveComponent("masked-api-key")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_masked_api_key, {
      "service-account": _ctx.serviceAccount,
      "onUpdate:serviceAccount": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:service-account', $event)))
    }, null, 8, ["service-account"])
  ]))
}